import { ActionTree, GetterTree, ModuleTree, MutationTree } from "vuex";
import { ViewedDepot } from "@/common/types/DepotDto";

export const FETCH_LAST_VIEWED_DEPOT: string = 'FETCH_LAST_VIEWED_DEPOT';
export const LAST_VIEWED_DEPOTS: string = 'LAST_VIEWED_DEPOTS';
export const ADD_LAST_VIEWED_DEPOT: string = 'ADD_LAST_VIEWED_DEPOT';

export type CommonStore = {
    lastViewedDepots: Array<ViewedDepot>
};

type RootState = {}

const state: CommonStore = {
  lastViewedDepots: []
};

const getters: GetterTree<CommonStore, RootState> = {
  LAST_VIEWED_DEPOTS: (store: CommonStore) => store.lastViewedDepots,
};

const actions: ActionTree<CommonStore, RootState> = {
  [FETCH_LAST_VIEWED_DEPOT]: ({ commit }) => {
    commit(FETCH_LAST_VIEWED_DEPOT);
  },
  [ADD_LAST_VIEWED_DEPOT]: ({ commit, dispatch }, depot: ViewedDepot) => {
    commit(ADD_LAST_VIEWED_DEPOT, depot);
  },
};

const mutations: MutationTree<CommonStore> = {
  [FETCH_LAST_VIEWED_DEPOT]: (store) => {
    store.lastViewedDepots = JSON.parse(<string>localStorage.getItem('last-viewed-depots')) || [];
  },
  [ADD_LAST_VIEWED_DEPOT]: (store, depot) => {
    if (depot.id) {
      let depotWithDate = {
        ...depot,
        at: Date.now()
      } as ViewedDepot;

      let exitingEntry = state.lastViewedDepots.find(viewedDepot => {
        return viewedDepot.id === depotWithDate.id;
      });

      if (exitingEntry) {
        exitingEntry.at = depotWithDate.at;
      } else {
        state.lastViewedDepots.push(depotWithDate);
      }

      state.lastViewedDepots.sort((viewedDepot1: ViewedDepot, viewedDepot2: ViewedDepot): number => {

        if (!viewedDepot1.at || !viewedDepot2.at) {
          return 0;
        }

        if (viewedDepot1.at > viewedDepot2.at) {
          return -1;
        }

        if (viewedDepot1.at < viewedDepot1.at) {
          return 1;
        }

        return 0;
      });

      if (state.lastViewedDepots.length > 5) {
        state.lastViewedDepots.length = 5;
      }

      localStorage.setItem('last-viewed-depots', JSON.stringify(state.lastViewedDepots));
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
} as ModuleTree<CommonStore>;
